import React, { Fragment } from "react";
import "../dashboard.css";
import { AthleteHeader } from "./athleteheader";
import { Footer } from "../footer";

export const AthleteDashboard = () => {
  return (
    <Fragment>
      <AthleteHeader />
      <div id="content-page" className="content-page">
        <div className="container-fluid">

          <div className="row">
            {/* <div className="col-md-6 col-lg-3 ath_card">
              <div className="iq-card-block iq-card-stretch iq-card-height overflow-hidden card-1">
                <div className="iq-card-body">
                  <div className="text-center mb-2">
                    <div className="rounded-circle iqa-card-icon iq-bg-info">
                      <i className="ri-user-line"></i>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <div className="text-center">
                    <h2 className="mb-0">JSWMA00012</h2>
                    <h6 className="mb-1">User Identity Number</h6>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-md-6 col-lg-3 ath_card">
              <div className="iq-card-block iq-card-stretch iq-card-height overflow-hidden card-2">
                <div className="iq-card-body">
                  <div className="text-center mb-2">
                    <div className="rounded-circle iqa-card-icon iq-bg-danger">
                      <i className="ri-admin-line"></i>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <div className="text-center">
                    <h2 className="mb-0">
                      <span>Mariyadas</span>
                    </h2>
                    <h6 className="mb-1">Coach Name</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 ath_card">
              <div className="iq-card-block iq-card-stretch iq-card-height overflow-hidden card-3">
                <div className="iq-card-body">
                  <div className="text-center mb-2">
                    <div className="rounded-circle iqa-card-icon iq-bg-warning">
                      <i className="ri-building-line"></i>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <div className="text-center">
                    <h2 className="mb-0">
                      <span>Biju Patnaik</span>
                    </h2>
                    <h6 className="mb-1">Swimming Center</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 ath_card">
              <div className="iq-card-block iq-card-stretch iq-card-height overflow-hidden card-4">
                <div className="iq-card-body">
                  <div className="text-center mb-2">
                    <div className="rounded-circle iqa-card-icon iq-bg-success">
                      <i className="ri-slack-line"></i>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <div className="text-center">
                    <h2 className="mb-0">
                      <span>DOLPHIN</span>
                    </h2>
                    <h6 className="mb-1">Level of Athlete</h6>
                  </div>
                </div>
              </div>
            </div> */}
           
          </div>
          <br/>
        
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};
